<template>
    <div class="column is-half is-offset-one-quarter">
        <div class="box">
            <table class="table is-striped is-fullwidth">
                <tbody>
                    <tr v-for="list in mailinglists.visible" v-bind:key="list.name">
                        <td>{{list.description}}</td>
                        <td v-if="!list.member"><a @click="subscribe(list)">Eintragen</a></td>
                        <td v-if="list.member"><a @click="unsubscribe(list)">Austragen</a></td>
                    </tr>
                    <tr v-for="list in mailinglists.hidden" v-bind:key="list.name">
                        <td>{{list.description}}</td>
                        <td v-if="!list.member"><a @click="subscribe(list)">Eintragen</a></td>
                        <td v-if="list.member"><a @click="unsubscribe(list)">Austragen</a></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import {API} from '@/assets/ts/api'
export default {
    data() {
        return {
            mailinglists: {
            }
        }
    },
    beforeCreate() {
        API.getOwnMailinglists().then((response) => {
            this.mailinglists = response.data
        })
    },    
    methods: {
        subscribe(list) {
            API.subscribeToMailinglist(list.name).then(() => {
                list.member = !list.member;
            });
        },
        unsubscribe(list) {
            API.unsubscribeFromMailinglist(list.name).then(() => {
                list.member = !list.member;
            });
        }
    }
}
</script>

<style>

</style>
